export type UnorderedProductForm = {
  scannedCode: string
  measureUnit: string
  receivedQuantity: string
  unitsPerLogisticUnit: string
  pcbNumber: string
  articleName: string
  expirationDate: string
}

export type DSReceptionProductUnorderedReceivedDTO = {
  scannedCode: string
  measureUnit: string
  receivedQuantity: number
  unitsPerLogisticUnit: number
  pcbNumber: number
  articleName: string
  expirationDate: string | null
}

export const serializeUnorderedReceptionProduct = (
  form: UnorderedProductForm
): DSReceptionProductUnorderedReceivedDTO => ({
  scannedCode: form.scannedCode.trim(),
  measureUnit: form.measureUnit.trim(),
  receivedQuantity: Number(form.receivedQuantity),
  unitsPerLogisticUnit: Number(form.unitsPerLogisticUnit),
  pcbNumber: Number(form.pcbNumber),
  articleName: form.articleName.trim(),
  expirationDate: form.expirationDate.trim() ? form.expirationDate : null
})
